import { createSlice } from "@reduxjs/toolkit";

const createCompanySlice = createSlice({
  name: "companyCreate",
  initialState: {
    currentCompany: null,
    isFetching: false,
    error: false
  },
  reducers: {
    createCompanyStart: (state) => {
      state.isFetching = true;
    },
    createCompanySuccess: (state, action) => {
        state.isFetching = false;
        state.currentCompany = action.payload
        state.error = false;
    },
    createCompanyFailure: (state) => {
        state.currentCompany = null;
        state.isFetching = false;
        state.error = true;
    }
  },
});


export const { createCompanyStart, createCompanySuccess, createCompanyFailure } = createCompanySlice.actions;
export default createCompanySlice.reducer;